import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { State } from '../../../cmsPage.widget'
import { renderModernBlocks } from '../../../cmsPage.layout'
import { overviewWidget } from '../widgets/overviewWidget'

export const storyOverviewPageWidget = (state: State): Widget<Updater<State>> => {
  return fromJSX((setState) => {
    return (
      <div>
        {renderModernBlocks(state, setState)}
        {overviewWidget(state.storyOverviewPageState.overviewState, state).run((u) =>
          setState((s) => ({
            ...s,
            storyOverviewPageState: {
              ...s.storyOverviewPageState,
              overviewState: u(s.storyOverviewPageState.overviewState),
            },
          }))
        )}
      </div>
    )
  })
}